export const getCmsPageSection = (sectionName = "", pageSections = []) => {
    const item = pageSections.find((section) => section?.pageSection?.meta?.type === sectionName);
    if (item) {
        return item;
    }
    return null;
};
